export const isEmptyObject = (entries: object) =>
  !Object.values(entries).filter(Boolean).length;
